import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UsertokenService } from '../services/usertoken.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const ut = inject(UsertokenService).getUserToken();
  if (!ut) return next(req);
  return next(req.clone({ setHeaders: { 'Ut': ut } }));
};